<div class="container gauge-container">
  <h4>Mood Sentiment Analytics</h4>

  <div class="card">
    <!-- ================= FILTERS ================= -->
    <div class="card-header">
      <div class="filters">

        <!-- Select All -->
        <button
          nbButton
          (click)="clearFilter()"
          [status]="!isAnyFilterActive() ? 'primary' : 'basic'"
        >
          Select All
        </button>

        <!-- ================= BUSINESS UNIT ================= -->
        <nb-select
          placeholder="Select BU"
          [(ngModel)]="selectedBU"
          multiple
          (ngModelChange)="onBUChange()"
        >
          <nb-option
            *ngFor="let bu of filterData.businessUnits"
            [value]="bu"
          >
            {{ bu }}
          </nb-option>
        </nb-select>

        <!-- ================= DELIVERY UNIT ================= -->
        <nb-select
          placeholder="Select Delivery Group"
          [(ngModel)]="selectedDG"
          multiple
          [disabled]="filteredDeliveryGroups.length === 0"
          (ngModelChange)="onDGChange()"
        >
          <nb-option *ngFor="let group of filteredDeliveryGroups" [value]="group">
            {{ group }}
          </nb-option>
        </nb-select>

        <nb-select
          placeholder="Select DU"
          [(ngModel)]="selectedDU"
          multiple
          [disabled]="filteredDeliveryUnits.length === 0"
          (ngModelChange)="onFilterChange()"
        >
          <nb-option
            *ngFor="let du of filteredDeliveryUnits"
            [value]="du"
          >
            {{ du }}
          </nb-option>
        </nb-select>

        <!-- ================= GENDER ================= -->
        <nb-select
          placeholder="Select Gender"
          [(ngModel)]="selectedGender"
          multiple
          (ngModelChange)="onFilterChange()"
        >
          <nb-option value="male">Male</nb-option>
          <nb-option value="female">Female</nb-option>
        </nb-select>

        <!-- ================= GRADE ================= -->
        <nb-select
          placeholder="Select Grade"
          [(ngModel)]="selectedGrade"
          multiple
          (ngModelChange)="onFilterChange()"
        >
          
          <nb-option
            *ngFor="let grade of filterData.grades"
            [value]="grade"
          >
            {{ grade }}
          </nb-option>
        </nb-select>

        <!-- ================= LOCATION ================= -->
         <nb-select
          placeholder="Select Country"
          [(ngModel)]="selectedCountry"
          multiple
          (ngModelChange)="onCountryChange($event)"
        >
          <nb-option
            *ngFor="let loc of filterData.country"
            [value]="loc"
          >
            {{ loc }}
          </nb-option>
        </nb-select>
        <nb-select
          placeholder="Select Location"
          [(ngModel)]="selectedLocation"
          multiple
          (ngModelChange)="onFilterChange()"
        >
          <nb-option
            *ngFor="let loc of filterBaseLocation"
            [value]="loc"
          >
            {{ loc }}
          </nb-option>
        </nb-select>

        

        <!-- ================= DATE FILTER ================= -->
        <div class="date">
          <div style="display: flex; align-items: center; width: 48%;">
            <input
              nbInput
              class="fromDate"
              placeholder="From Date"
              [nbDatepicker]="startPicker"
              [(ngModel)]="fromDateValue"
              (ngModelChange)="onDateChange()"
            />
            <nb-icon icon="calendar-outline" class="fromDateIcon"></nb-icon>
            <nb-datepicker
              #startPicker
              [max]="toDateValue"
              format="dd MMM yy"
            ></nb-datepicker>
          </div>

          <div style="display: flex; align-items: center; width: 48%;">
            <input
              nbInput
              class="toDate"
              placeholder="Till Date"
              [nbDatepicker]="endPicker"
              [(ngModel)]="toDateValue"
              (ngModelChange)="onDateChange()"
            />
            <nb-icon icon="calendar-outline" class="toDateIcon"></nb-icon>
            <nb-datepicker
              #endPicker
              [min]="fromDateValue"
              [max]="today"
              format="dd MMM yy"
            ></nb-datepicker>
          </div>
        </div>

      </div>
    </div>

    <!-- ================= MAIN GRAPH ================= -->
    <div class="graph-body">
      <div class="main-graph">
        <div echarts [options]="gaugeOption" class="demo-chart"></div>
      </div>
    </div>

    <!-- ================= SUB GRAPHS ================= -->
    <div class="sub-graph-body">
      <div class="sub-graph">
        <ltts-excellent-gauge-chart
          [excellentData]="excellentData"
          [dataPercent]="graphData?.excellent?.percentage"
        ></ltts-excellent-gauge-chart>
      </div>

      <div class="sub-graph">
        <ltts-happy-guage-chart
          [happyData]="happyData"
          [dataPercent]="graphData?.happy?.percentage"
        ></ltts-happy-guage-chart>
      </div>

      <div class="sub-graph">
        <ltts-ok-gauge-chart
          [okData]="okData"
          [dataPercent]="graphData?.okay?.percentage"
        ></ltts-ok-gauge-chart>
      </div>

      <div class="sub-graph">
        <ltts-not-ok-gauge-chart
          [notOkData]="notOkData"
          [dataPercent]="graphData?.notOkay?.percentage"
        ></ltts-not-ok-gauge-chart>
      </div>
     </div>

    <!-- ================= FOOTER ================= -->
    <div class="message">
      <p>
        Data is Processed till
        <strong>{{ formattedDate }}</strong>
      </p>
      <div class="underline"></div>
    </div>

  </div>
</div>
